import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API } from '../config';
import { IconSignal } from '../components/Icons';

const IconPause = ({ size = 16 }) => (<svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor"><rect x="6" y="5" width="4" height="14" rx="1" /><rect x="14" y="5" width="4" height="14" rx="1" /></svg>);
const nf = (n) => (n == null ? '—' : Number(n).toLocaleString('it-IT'));
const TECS = ['FTTH', 'FTTC', 'FWA', 'ADSL'];
const TEC_COL = { FTTH: '#3b82f6', FTTC: '#0ea5e9', FWA: '#a855f7', ADSL: '#94a3b8' };
const ESITI = [['COPERTO', '#16a34a'], ['NON COPERTO', '#64748b'], ['NON CENSITO', '#f59e0b'], ['ERRORE', '#ef4444']];

function Bar({ c, l, p, v }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '7px 2px' }}>
      <span style={{ width: 12, height: 12, borderRadius: '50%', background: c, flex: '0 0 auto' }} />
      <span style={{ flex: 1, fontSize: 13 }}>{l}</span>
      <div style={{ flex: '0 0 70px', height: 6, background: 'var(--line)', borderRadius: 4, overflow: 'hidden' }}>
        <div style={{ width: `${p}%`, height: '100%', background: c }} />
      </div>
      <span style={{ flex: '0 0 54px', textAlign: 'right', fontSize: 13, fontWeight: 700 }}>{nf(v)} · {p}%</span>
    </div>
  );
}

export default function CoperturaPage() {
  const [d, setD] = useState(null);
  const [stato, setStato] = useState(null);
  const [newFtth, setNewFtth] = useState(0);
  const nav = useNavigate();
  const load = useCallback(() => {
    axios.get(`${API}/copertura/dashboard`).then((r) => setD(r.data)).catch(() => {});
    axios.get(`${API}/copertura/stato`).then((r) => setStato(r.data)).catch(() => {});
    axios.get(`${API}/numeri?copertura_new=true&limit=1`).then((r) => setNewFtth(r.data?.total ?? 0)).catch(() => {});
  }, []);
  useEffect(() => { load(); const t = setInterval(load, 10000); return () => clearInterval(t); }, [load]);

  if (!d) return <div className="m-empty">Caricamento…</div>;

  const attivo = d.agente_attivo;
  const job = stato?.job;
  const coperti = d.per_esito?.COPERTO || 0;
  const totEsiti = ESITI.reduce((s, [k]) => s + (d.per_esito?.[k] || 0), 0);
  const totTec = TECS.reduce((s, k) => s + (d.per_tecnologia?.[k] || 0), 0);

  return (
    <>
      <div className={`m-verdict ${attivo ? '' : 'warn'}`}>
        <span className="vi">{attivo ? <IconSignal size={16} /> : <IconPause size={16} />}</span>
        <div>
          <div className="vt">{d.abilitata === false ? 'Verifica disabilitata' : attivo ? (job ? 'AI in verifica' : 'AI in attesa') : 'AI Copertura fermo'}</div>
          <div className="vs">{job ? `${nf(job.completed)}/${nf(job.total)}${job.velocita_min ? ` · ${nf(job.velocita_min)}/min` : ''}` : `${nf(d.verificabili)} verificabili`}</div>
        </div>
      </div>

      {newFtth > 0 && (
        <button className="m-alert2" onClick={() => nav('/liste?ftth=1')}>
          <span className="ab"><IconSignal size={13} /></span>
          <span className="at"><b>{nf(newFtth)}</b> {newFtth > 1 ? 'diventati' : 'diventato'} <b>FTTH</b> — contattali per primo</span>
          <span className="aa">→</span>
        </button>
      )}

      <div className="m-secrow"><h2>Copertura</h2></div>
      <div className="m-chips">
        <div className="m-chip"><div className="cn">{nf(d.verificati)}</div><div className="cl">Verificati</div></div>
        <div className="m-chip k-cop"><div className="cn">{nf(coperti)}</div><div className="cl">Coperti</div></div>
        <div className="m-chip k-non"><div className="cn">{nf(d.pending)}</div><div className="cl">Da fare</div></div>
        <div className="m-chip k-lead"><div className="cn">{nf(d.per_tecnologia?.FTTH || 0)}</div><div className="cl">FTTH</div></div>
      </div>

      <div className="m-secrow"><h2>Tecnologie (coperti)</h2></div>
      {totTec === 0 ? (
        <div className="m-empty">Nessun coperto ancora.</div>
      ) : TECS.filter((k) => d.per_tecnologia?.[k]).map((k) => (
        <Bar key={k} c={TEC_COL[k]} l={k} p={Math.round((100 * d.per_tecnologia[k]) / totTec)} v={d.per_tecnologia[k]} />
      ))}

      <div className="m-secrow"><h2>Esiti</h2></div>
      {totEsiti === 0 ? (
        <div className="m-empty">Nessuna verifica.</div>
      ) : ESITI.filter(([k]) => d.per_esito?.[k]).map(([k, c]) => (
        <Bar key={k} c={c} l={k} p={Math.round((100 * d.per_esito[k]) / totEsiti)} v={d.per_esito[k]} />
      ))}

      <div className="m-secrow"><h2>Velocità media (coperti)</h2></div>
      <div className="m-chips">
        <div className="m-chip"><div className="cn">{d.medie?.down ? nf(d.medie.down) : '—'}</div><div className="cl">Down Mbps</div></div>
        <div className="m-chip"><div className="cn">{d.medie?.up ? nf(d.medie.up) : '—'}</div><div className="cl">Up Mbps</div></div>
        <div className="m-chip"><div className="cn">{d.medie?.latenza != null ? d.medie.latenza : '—'}</div><div className="cl">Latenza ms</div></div>
      </div>
    </>
  );
}
